module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order-logistical/order.component.scss
// module id = 1203
// module chunks = 0